import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import Sidebar_component from './Sidebar_component'
import $ from 'jquery'

export default function Meeting_room() {
    const [listMembersArray, setListMembersArray] = useState([]);
    const [selectedMembers, setSelectedMembers] = useState({});
    const [meetingTitle, setMeetingTitle] = useState('');
    const [meetingDescription, setMeetingDescription] = useState('');
    const [membretype, setMembertype] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    useEffect(() => {
        let memtype = localStorage.getItem('membership_type');
        if (memtype === 'free') {
            setMembertype(true);
        }
        let com_id = localStorage.getItem('mem_company_id');
        var obj = {
            com_id: com_id
        };

        console.log(obj);

        fetch('getAllCompanyMember.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(obj)
        })
            .then(response => response.json()) // ✅ auto JSON parse
            .then(res => {
                console.log(res);

                if (res !== 'fail' && res) {
                    // ensure it's an array
                    if (Array.isArray(res)) {
                        let len = res.length;

                        if (len < 1) {
                            showAlert('Cannot find any member.');
                            setListMembersArray([]);
                        } else {
                            setListMembersArray(res);
                        }
                    } else {
                        setListMembersArray([]);
                    }
                } else {
                    showAlert('Cannot find any member.');
                    setListMembersArray([]);
                }
            })
            .catch(error => {
                console.error("Fetch Error:", error);
                setListMembersArray([]);
            });
    }, [])

    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }

    function handleMemberSelect(memberId) {
        setSelectedMembers(prev => ({
            ...prev,
            [memberId]: !prev[memberId]
        }));
    }

    async function sendMeetingInvitation() {
        const company_id = localStorage.getItem('mem_company_id');
        const invited_by = localStorage.getItem('member_id');
        const member_ids = Object.keys(selectedMembers)
            .filter(id => selectedMembers[id]);
        if (member_ids.length < 1) {
            alert("Please select at least one member");
            return;
        }
        if (meetingTitle === '') {
            alert("Please enter meeting title");
            return;
        }
        const obj = {
            company_id,
            invited_by,
            member_ids,
            meeting_title: meetingTitle,
            meeting_description: meetingDescription
        };
        console.log(obj);
        try {
            const response = await fetch('sendMeetingInvitation.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(obj)
            });
            const res = await response.json();
            console.log(res);
            if (res.status === 'success') {
                showAlert("Meeting invitation sent successfully");
                setSelectedMembers({});
                setMeetingTitle('');
                setMeetingDescription('');
            } else {
                alert(res.message);
            }
        } catch (error) {
            console.log(error);
            alert("Something went wrong");
        }
    }

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='vl_alltab'>
                    <h2 className='bigfonttabs'>Arrange a Meeting</h2>
                    <p className='fullwidth pull_left pb-30'>Here you can invite members for a group chat to discuss regarding any issue.</p>
                </div>

                <div className='fullwidth pull_left mt-30 pb-30 meeting_section'>
                    <h2 className='pt-24'>Create Meeting</h2>
                    <div className='fullwidth pull_left pb-15'>
                        <input
                            type="text"
                            placeholder="Meeting Title"
                            value={meetingTitle}
                            onChange={(e) => setMeetingTitle(e.target.value)}
                        />
                    </div>
                    <div className='fullwidth pull_left pb-15'>
                        <textarea
                            placeholder="Meeting Description"
                            value={meetingDescription}
                            onChange={(e) => setMeetingDescription(e.target.value)}
                        ></textarea>
                    </div>
                </div>
                <div className=' fullwidth pull_left' id="mem_list">
                    <h2 className='fullwidth pull_left pt-24 pb-30'>Select Members You Want To Invite</h2>
                    {Array.isArray(listMembersArray) && listMembersArray.map((item, index) => {
                        return (
                            <div className='vl_listing_row'>
                                <div className='vl_listing_cell width20' key={index}>
                                    <input type="checkbox" checked={!!selectedMembers[item.primary_key]} onChange={() => handleMemberSelect(item.primary_key)} />&nbsp; {item.mem_fname} {item.mem_lname}
                                </div>
                            </div>
                        )
                    })}
                    <div className='vl_dsh_buttonholder pt-15'>
                        <button onClick={sendMeetingInvitation}>Send Invitation</button>
                    </div>
                </div>
            </div>
            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>
            {membretype && (
                <div className='vl_dsh_popup activebillpop'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>

                        <div className='contentarea'>
                            <p>Please upgrade your membership to access this page</p>
                        </div>
                        <div className='alert_btns'>
                            <button onClick={() => window.history.back()}>Back</button>
                        </div>

                    </div>
                </div>
            )}
        </div>
    )
}
